import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, "Module count horizontal", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, "Module count vertical", -1 /* HOISTED */)
const _hoisted_3 = { class: "config-device" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

import { computed, onMounted, ref, watch } from "vue";
import ModuleSelectorModal from "@src/modules/DeviceConfigurator/ModuleSelectorModal.vue";
import { getModuleDefinition } from "@src/config/moduleDefinition";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomDeviceConfigurationModal',
  emits: ["apply", "close"],
  setup(__props, { emit }) {



const tickLabels = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
};

const modulesWidth = ref(2);
const modulesHeight = ref(2);
const isModalVisible = ref(true);
const selectedModuleSlot = ref<number | null>(null);
const isModuleSelectModalVisible = ref(false);
const selectedModules = ref<Array<string | null>>([]);

watch(() => modulesWidth.value, regenerateModules);
watch(() => modulesHeight.value, regenerateModules);

const numberOfModules = computed(() => {
  return modulesWidth.value * modulesHeight.value;
});

function regenerateModules(): void {
  const size = modulesWidth.value * modulesHeight.value;
  selectedModules.value = Array(size);
  selectedModules.value.fill("placeholder", 0, size);
}

function showModuleSelector(index: number): void {
  selectedModuleSlot.value = index;
  isModuleSelectModalVisible.value = true;
}

function selectModule(moduleName: string): void {
  if (selectedModuleSlot.value !== null) {
    selectedModules.value[selectedModuleSlot.value] = moduleName;
  }
  isModuleSelectModalVisible.value = false;
  selectedModuleSlot.value = null;
}

function applyConfiguration(): void {
  if (!selectedModules.value.some((val) => val === "timer")) {
    return;
  }

  //TODO: Show error message

  emit("apply", modulesWidth.value, modulesHeight.value, selectedModules.value);
}

function close(): void {
  emit("close");
}

onMounted(() => {
  regenerateModules();
});

function getImage(moduleName: string): string {
  const module = getModuleDefinition(moduleName);

  return module?.imageUrl ?? "";
}

return (_ctx: any,_cache: any) => {
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: isModalVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isModalVisible).value = $event)),
      width: "auto",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_v_slider, {
                  modelValue: modulesWidth.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modulesWidth).value = $event)),
                  ticks: tickLabels,
                  min: 1,
                  max: 4,
                  step: "1",
                  "show-ticks": "always",
                  "tick-size": "4"
                }, null, 8 /* PROPS */, ["modelValue"]),
                _hoisted_2,
                _createVNode(_component_v_slider, {
                  modelValue: modulesHeight.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modulesHeight).value = $event)),
                  ticks: tickLabels,
                  min: 1,
                  max: 4,
                  step: "1",
                  "show-ticks": "always",
                  "tick-size": "4"
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["config-device-row", ['device-width-' + modulesWidth.value]])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfModules.value, (num, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "config-module",
                        onClick: () => showModuleSelector(index)
                      }, [
                        _createElementVNode("img", {
                          src: getImage(<string>selectedModules.value[index]),
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_5)
                      ], 8 /* PROPS */, _hoisted_4))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 2 /* CLASS */)
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "outlined",
                  onClick: applyConfiguration
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Apply configuration ")
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_btn, {
                  color: "secondary",
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Close")
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    (isModuleSelectModalVisible.value)
      ? (_openBlock(), _createBlock(ModuleSelectorModal, {
          key: 0,
          onSelect: selectModule,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (isModuleSelectModalVisible.value = false))
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})